import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
import SeguimientoTutoresContent from './components/SeguimientoTutoresContent';

const SeguimientoTutoresListado = () => {

    return (
        <>

            <TemplateDashboard>
                <SeguimientoTutoresContent />
            </TemplateDashboard>

        </>
    )
};

export default SeguimientoTutoresListado;